import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import "./Loader.css";
import React from "react";

export const Loader = () => {
	const texts = [
		"Mientras esperas, imagina los sabores que están por venir.",
		"While you wait, imagine the flavors that are yet to come.",
		"Enquanto espera, imagine os sabores que estão por vir.",
	];
	const [typedText, setTypedText] = useState("");
	const [index, setIndex] = useState(0);
	const [textIndex, setTextIndex] = useState(0);

	useEffect(() => {
		//Si el texto no se termina de escribir, sigo escribiendo letra por letra y aumento el index
		const typeText = () => {
			if (index < texts[textIndex].length) {
				setTypedText((prevText) => prevText + texts[textIndex].charAt(index));
				setIndex((prevIndex) => prevIndex + 1);
			}
		};

		const eraseText = () => {
			if (typedText.length > 0) {
				setTypedText((prevText) => prevText.slice(0, -1)); // Elimina un carácter
			} else {
				setTimeout(() => {}, 10000);
				// Ha terminado de borrar, pasa al siguiente texto
				setTextIndex((prevTextIndex) => (prevTextIndex + 1) % texts.length);
				setIndex(0);
			}
		};

		let timer;
		//Si el texto no se termina de escribir, llamo a la funcion de escribir.
		if (index < texts[textIndex].length) {
			timer = setTimeout(typeText, 50);
		} else {
			//Si el texto no se termina de escribir, llamo a la funcion de borrar.
			//Si estoy justo empezando a borrar, espero un poquito para que se lea el texto.
			if (typedText === texts[textIndex])
				timer = setTimeout(() => {
					eraseText();
				}, 2000);
			else
				timer = setTimeout(() => {
					eraseText();
				}, 10);
		}
		
		return () => clearTimeout(timer); // Limpiar el temporizador cuando el componente se desmonte o index cambie
		// eslint-disable-next-line
	}, [index, typedText]);

	return (
		<Box className="loaderContainer">
			<span className="loader"></span>
			<Typography
				className="typingEffect"
				color="white"
				variant="h6"
				sx={{
					maxWidth: "90%",
					textAlign: "center"
				}}
			>
				{typedText}
			</Typography>
		</Box>
	);
};
